var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-slide-group',{staticClass:"background"},_vm._l((_vm.unsavedTrips),function(trip,index){return _c('v-slide-item',{key:index},[_c('div',{staticClass:"pa-2 mt-2 rounded-lg background",staticStyle:{"max-width":"300px"}},[_c('UnsavedTripCard',{attrs:{"trip":trip}})],1)])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }